<template>
  <ExternalList
      headline="Open Opportunities"
      endpoint="/api/v2/opportunities"
      :endpoint-filters="{company_id: company.data.id, status: 'open'}"
      :headlines="headlines"
      :can-update="() => true"
      :show-checkboxes="false"
      :show-list-actions="false"
      :button-column-width="2"
      :page-size-options="null"
      :default-page-size="100"
      @show="opportunity => $router.push(getUrl(opportunity))"
  >
    <template v-slot:default="{ row: opportunity }">
      <td>
        {{ opportunity.attributes.portal_name }}
      </td>

      <td>
        <Avatar :color="opportunity.attributes.user_color">
          {{ opportunity.attributes.user_initials }}
        </Avatar>
      </td>

      <td>
        {{ opportunity.attributes.category | ucfirst }}
      </td>

      <td>
        {{ opportunity.attributes.conversion_expected_at | date }}
      </td>

      <td>
        {{ opportunity.attributes.value | price }}
      </td>
    </template>
  </ExternalList>
</template>

<script>
import Avatar from '../../../Avatar'
import ExternalList from '../../../Panels/Lists/External'

export default {
  components: {Avatar, ExternalList},

  props: {
    company: {
      required: true
    }
  },

  computed: {
    headlines() {
      return [
        {width: 6, text: 'Portal'},
        {width: 4, text: 'User'},
        {width: 4, text: 'Category'},
        {width: 4, text: 'Expected', description: 'Conversion Expected'},
        {width: 4, text: 'Value'},
      ]
    }
  },

  methods: {
    getUrl(opportunity) {
      return '/companies/' + opportunity.attributes.company_id + '/opportunities/' + opportunity.id
    }
  }
}
</script>
